import React from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import { useRegistrationsContext } from "../context/registrations_context";

const AdminGroupItem = ({ item, index, size }) => {
  const { registrations } = useRegistrationsContext();
  const regsFiltered = registrations.filter((r) => r.username === item);
  var register;

  if (regsFiltered.length > 0) {
    register = regsFiltered[0];
  }

  if (register) {
    return (
      <Draggable draggableId={`item-${item}`} index={index}>
        {(provided, snapshot) => {
          return (
            <DragItem
              ref={provided.innerRef}
              snapshot={snapshot}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className={`${size ? "small-item" : ""}`}
            >
              <CardHeader>{register.username}</CardHeader>
              <CardFooter>
                <span>Elo AVG: {register.elo_avg}</span>
                <span>AoE2net: {register.aoe2net_principal}</span>
                <span>Div T4: {register.division_t4}</span>
                <span>Ascenso/descenso T4?: {register.position_t4}</span>
                <span>Seed T4: {register.seed_t4}</span>
                <span>Seed T5 group: {index}</span>
              </CardFooter>
            </DragItem>
          );
        }}
      </Draggable>
    );
  }
  return "";
};

const CardHeader = styled.div`
  font-weight: bold;
`;

const CardFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  span {
    font-style: italic;
  }
`;

const DragItem = styled.div`
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px var(--clr-copper), 0 1px 2px rgba(0, 0, 0, 0.24);
  background: var(--clr-black);
  margin: 0 0 8px 0;

  flex-direction: column;
`;

export default AdminGroupItem;
